import EntitlementsModel from '../models/EntitlementsModel';
import { entitlementsDefaults } from './defaults';

export default {
    ...entitlementsDefaults,
    pathTemplate: `?principalType=user&principalId={uid}&includeFeatures=true`,
    expires: false,
    model: EntitlementsModel,
    headers: {
        'Authorization': `Bearer {accessToken}`
    }
};
